import React from 'react'
import { Table } from 'reactstrap'

import { slotForColor } from '../activityReport'

/**
 * The table view behind every chart.
 *
 * This is not just a convenience: three palette slots sit below 3:1 contrast on
 * a white surface, and the colour method's relief rule requires either visible
 * direct labels or a table view. This is that table.
 *
 * `rows` is [{ name, values: { [seriesKey]: number }, total }].
 */
const DataTable = ({ rows, series, rowHeader = 'User' }) => {
    if (!rows.length || !series.length) {
        return <div className="incident-reports-status">No results for the selected date range.</div>
    }

    return (
        <>
            <div className="incident-reports-table">
                <Table responsive className="incident-reports-table-inner">
                    <thead>
                        <tr>
                            <th>{rowHeader}</th>
                            {series.map((item) => (
                                <th key={item.key}>{item.label}</th>
                            ))}
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row) => (
                            <tr key={row.name}>
                                <td className="incident-reports-sticky-col">{row.name}</td>
                                {series.map((item) => {
                                    const value = row.values[item.key] || 0
                                    return (
                                        <td key={item.key}>
                                            <span
                                                className={
                                                    value > 0
                                                        ? `incident-reports-cell-highlight viz-chip viz-chip--${slotForColor(item.color)}`
                                                        : 'incident-reports-cell-zero'
                                                }
                                            >
                                                {value > 0 ? value.toLocaleString() : '-'}
                                            </span>
                                        </td>
                                    )
                                })}
                                <td className="viz-table-total">{row.total.toLocaleString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            <div className="incident-reports-note">Tip: scroll horizontally to see every column.</div>
        </>
    )
}

export default DataTable
